// src/features/learner/components/ContentRenderers/MCQRenderer.js
import React from 'react';
import { AudioPlayer } from '../../../../features/MediaLibrary';

export const MCQRenderer = ({
    unit,
    userAnswers,
    showFeedback,
    onAnswerSelect,
    onCheckAnswer,
    onMarkCompleted,
    onResetUnit,
    getRandomizedOptions
}) => {
    const content = unit.content || {};
    const showFeedbackForUnit = showFeedback[unit.id];
    const userAnswer = userAnswers[unit.id];

    const displayOptions = getRandomizedOptions
        ? getRandomizedOptions(unit.id, content.options)
        : content.options || [];

    const handleOptionClick = (optionId) => {
        if (!showFeedbackForUnit && onAnswerSelect) {
            onAnswerSelect(unit.id, optionId);
        }
    };

    const handleCheckAnswer = () => {
        if (onCheckAnswer) onCheckAnswer(unit.id);

        const isCorrect = content.options?.find(o => o.id === userAnswer)?.isCorrect;
        if (onMarkCompleted) {
            onMarkCompleted(unit.id, null, isCorrect ? 'correct' : 'wrong');
        }
    };

    return (
        <div className="unit-content mcq-content">
                        {/* Stem text */}
            <div className="mcq-stem">
                <div dangerouslySetInnerHTML={{ __html: content.stem || '' }} />
            </div>

            {/* Stem audio — only shown if present */}
            {content.stemAudio && (
                <div style={{ marginBottom: '12px' }}>
                    <AudioPlayer audioUrl={content.stemAudio} />
                </div>
            )}

            {/* Options */}
            <div className="mcq-options">
                {displayOptions.map(option => (
                    <div
                        key={option.id}
                        className={`mcq-option ${userAnswer === option.id ? 'selected' : ''} ${
                            showFeedbackForUnit && option.isCorrect ? 'correct' : ''
                        } ${
                            showFeedbackForUnit && userAnswer === option.id && !option.isCorrect
                                ? 'incorrect'
                                : ''
                        }`}
                        onClick={() => handleOptionClick(option.id)}
                    >
                        <div className="option-text">{option.text}</div>
                    </div>
                ))}
            </div>

            {!showFeedbackForUnit ? (
                <button
                    className="check-answer-button"
                    onClick={handleCheckAnswer}
                    disabled={!userAnswer}
                >
                    Check Answer
                </button>
            ) : (
                <div className={`feedback-container ${
                    content.options?.find(o => o.id === userAnswer)?.isCorrect ? 'correct' : 'incorrect'
                }`}>
                    <div className="feedback-header">
                        {content.options?.find(o => o.id === userAnswer)?.isCorrect ? 'Correct!' : 'Incorrect'}
                    </div>
                    <div className="feedback-text">
                        {content.options?.find(o => o.id === userAnswer)?.feedback}
                        {content.generalFeedback && (
                            <p className="general-feedback">{content.generalFeedback}</p>
                        )}
                    </div>
                    {!content.options?.find(o => o.id === userAnswer)?.isCorrect && onResetUnit && (
                        <div style={{ textAlign: 'center', marginTop: '12px' }}>
                            <button
                                className="reset-button"
                                onClick={() => onResetUnit(unit.id)}
                                title="Try again"
                                style={{
                                    padding: '8px 12px', fontSize: '18px',
                                    backgroundColor: '#6c757d', color: 'white',
                                    border: 'none', borderRadius: '50%', cursor: 'pointer',
                                    width: '40px', height: '40px',
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    margin: '0 auto', transition: 'all 0.2s ease',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                }}
                            >
                                🔄
                            </button>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};